import { NavLink } from 'react-router-dom';
import { api, type Me } from '../api';
import {
  IconHome, IconDashboard, IconChat, IconCart, IconBox, IconTruck, IconAlert,
  IconSettings, IconLogout, IconSun, IconMoon, IconTag,
} from './Icons';

// Global left navigation shared by every authenticated page. Dark violet
// gradient rail, grouped into Pilotage / Opérations, with a theme toggle and
// user card pinned to the bottom.
export default function NavRail({
  me,
  onLogout,
  theme,
  onToggleTheme,
}: {
  me: Me;
  onLogout: () => void;
  theme: 'light' | 'dark';
  onToggleTheme: () => void;
}) {
  async function logout() {
    await api.logout();
    onLogout();
  }

  const initial = (me.username || '?').charAt(0).toUpperCase();

  return (
    <nav className="nav-rail">
      <div className="nav-brand">
        <div className="nav-brand-tile">S</div>
        <div className="nav-brand-text">
          <div className="nav-brand-name">STM Partners</div>
          <div className="nav-brand-sub">Cockpit Odoo</div>
        </div>
      </div>

      <div className="nav-section">Pilotage</div>
      <div className="nav-items">
        <NavLink to="/" end className="nav-item" title="Centre de contrôle">
          <span className="nav-ico"><IconHome size={19} /></span>
          <span className="nav-label">Accueil</span>
        </NavLink>
        <NavLink to="/tableaux" className="nav-item" title="Tableaux de bord">
          <span className="nav-ico"><IconDashboard size={19} /></span>
          <span className="nav-label">Tableaux de bord</span>
        </NavLink>
        <NavLink to="/chat" className="nav-item" title="Assistant">
          <span className="nav-ico"><IconChat size={19} /></span>
          <span className="nav-label">Assistant</span>
          <span className="nav-badge">IA</span>
        </NavLink>
      </div>

      <div className="nav-section">Opérations</div>
      <div className="nav-items">
        <NavLink to="/ventes" className="nav-item" title="Ventes : devis, commandes, factures">
          <span className="nav-ico"><IconCart size={19} /></span>
          <span className="nav-label">Ventes</span>
        </NavLink>
        <NavLink to="/stocks" className="nav-item" title="Stocks">
          <span className="nav-ico"><IconBox size={19} /></span>
          <span className="nav-label">Stocks</span>
        </NavLink>
        <NavLink to="/lots" className="nav-item" title="Traçabilité par lot (rappel produit)">
          <span className="nav-ico"><IconTag size={19} /></span>
          <span className="nav-label">Traçabilité</span>
        </NavLink>
        <NavLink to="/achats" className="nav-item" title="Achats fournisseurs">
          <span className="nav-ico"><IconTruck size={19} /></span>
          <span className="nav-label">Achats</span>
        </NavLink>
        <NavLink to="/journal" className="nav-item" title="Journal technique">
          <span className="nav-ico"><IconAlert size={19} /></span>
          <span className="nav-label">Journal</span>
        </NavLink>
      </div>

      <div className="nav-bottom">
        {me.is_admin && (
          <NavLink to="/admin" className="nav-item" title="Administration">
            <span className="nav-ico"><IconSettings size={19} /></span>
            <span className="nav-label">Admin</span>
          </NavLink>
        )}
        <button
          className="nav-item nav-logout"
          onClick={onToggleTheme}
          title={theme === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre'}
        >
          <span className="nav-ico">{theme === 'dark' ? <IconSun size={19} /> : <IconMoon size={19} />}</span>
          <span className="nav-label">{theme === 'dark' ? 'Mode clair' : 'Mode sombre'}</span>
        </button>
        <div className="nav-user">
          <div className="nav-user-avatar">{initial}</div>
          <div className="nav-user-info">
            <div className="nav-user-name">{me.username}{me.is_admin ? ' ★' : ''}</div>
            <div className="nav-user-role">{me.is_admin ? 'Administrateur' : 'Utilisateur'}</div>
          </div>
          <button className="nav-user-logout" onClick={logout} title={`Déconnexion (${me.username})`}>
            <IconLogout size={17} />
          </button>
        </div>
      </div>
    </nav>
  );
}
